import { City } from './city';

export class Bank {

    id: number|undefined;
    active:boolean;
    code: string;
    label:string;
    description:string;
    city:City;
    address:string;
    ville:string;
  
  }
  